up.compiler('[data-measure-width]', (element: HTMLElement) => {
  const resizeObserver = new ResizeObserver((entries) => {
    for (const entry of entries) {
      const width = entry.contentRect.width
      element.style.setProperty('--width', `${width}px`)
    }
  })

  resizeObserver.observe(element)

  return () => {
    resizeObserver.unobserve(element)
  }
})
